import { IXmlNode } from '@/app-modules/server-communications';
import { injectable } from 'inversify';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { container } from '@/app-modules/_ioc';
import { IPersistedStore } from '@/app-modules/store/persisted-store';
import { PrizeWinnerData } from '@/components/game/_domain/server/prize-winner/prize-winner-data';
import { GameIdentity } from '@/components/game/_domain/models';
import { DefaultPrizeWinnerData } from '@/components/game/implementations/_default/_domain/models/prize-winner';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';

import { Bingo40PrizeWinner } from '@/components/game/implementations/uk/bingo-40/_domain/models/prize-winner';
import { Bingo50PrizeWinner } from '@/components/game/implementations/uk/bingo-50/_domain/models';
import { Bingo60PrizeWinner } from '@/components/game/implementations/uk/bingo-60/_domain/models/prize-winner';
import { Bingo75LinesPrizeWinner } from '@/components/game/implementations/uk/bingo-75-lines/_domain/models/prize-winner';
import { Bingo80PrizeWinner } from '@/components/game/implementations/uk/bingo-80/_domain/models';
import { Bingo90PrizeWinner } from '@/components/game/implementations/uk/bingo-90/_domain/models';
import { BingoLitePrizeWinner } from '@/components/game/implementations/uk/bingo-lite/_domain/models';
import { BloomPrizeWinner } from '@/components/game/implementations/uk/bloom/_domain/models';
import { BubbleBingoPrizeWinner } from '@/components/game/implementations/uk/bubble-bingo/_domain/models/prize-winner';
import { HamsterRacePrizeWinner } from '@/components/game/implementations/uk/hamster-race/_domain/models';
import { MorphPrizeWinner } from '@/components/game/implementations/uk/morph/_domain/models/prize-winner';
import { NevadaPrizeWinner } from '@/components/game/implementations/uk/nevada/_domain/models';
import { PictureBingoPrizeWinner } from '@/components/game/implementations/uk/picture-bingo/_domain/models';
import { ESPictureBingoPrizeWinner } from '@/components/game/implementations/es/picture-bingo/_domain/models';
import { PiratesPrizeWinner } from '@/components/game/implementations/uk/pirates/_domain/models';
import { PotionPrizeWinner } from '@/components/game/implementations/uk/potion/_domain/models/prize-winner';
import { JigsawPrizeWinner } from '@/components/game/implementations/uk/jigsaw/_domain/models';
import { SEBingo75PrizeWinner } from '@/components/game/implementations/se/bingo-75/_domain/models/prize-winner';
import { ITBingo75PrizeWinner } from '@/components/game/implementations/it/bingo-75/_domain/models/prize-winner';
import { ReelBingoPrizeWinner } from '@/components/game/implementations/uk/reel-bingo/_domain/models';
import { PaintByNumbersPrizeWinner } from '@/components/game/implementations/uk/paint-by-numbers/_domain/models';
import { Bingo30PrizeWinner } from '@/components/game/implementations/uk/bingo-30/_domain/models';
import { StarshipPrizeWinner } from '@/components/game/implementations/uk/starship/_domain/models';
import { WordsearchPrizeWinner } from '@/components/game/implementations/uk/wordsearch/_domain/models';
import { DondBingoPrizeWinner } from '@/components/game/implementations/uk/dondbingo/_domain/models';


interface IPrizeWinnerDataFactory {
    getInstance(gameIdentity: GameIdentity, node: IXmlNode): PrizeWinnerData;
}

@injectable()
class PrizeWinnerDataFactory implements IPrizeWinnerDataFactory {
    private persistedStore = container.get(SERVICE_IDENTIFIERS.IPersistedStore) as IPersistedStore;
    private userPreferences: UserPreferences = this.persistedStore.Get(UserPreferences);

    public getInstance(gameIdentity: GameIdentity, node: IXmlNode): PrizeWinnerData {
        try {
            let gameIdentityName = gameIdentity.nameForConfiguration;
            if (gameIdentity.nameForConfiguration === 'bingo75') {
                // TODO: SE B75 and NL B75 is a special child, we need a better way of handling these cases
                if ((this.userPreferences.country.toLowerCase() === 'se' || this.userPreferences.country.toLowerCase() === 'nl')) {
                    gameIdentityName = 'seBingo75';
                }
                // TODO: This whole system needs reworks, this will fix it for now
                if (this.userPreferences.country.toLowerCase() === 'it') {
                    gameIdentityName = 'itBingo75';
                }
            }

            if (gameIdentity.nameForConfiguration === 'Picture Bingo') {
                if (this.userPreferences.country.toLowerCase() === 'es') {
                    gameIdentityName = 'esPictureBingo';
                }
            }
            return new (this.classNames as any)[gameIdentityName](node);
        } catch {
            return new DefaultPrizeWinnerData(node);
        }
    }

    private classNames = {
        bingo40: Bingo40PrizeWinner,
        bingo50: Bingo50PrizeWinner,
        bingo60: Bingo60PrizeWinner,
        bingo75lines: Bingo75LinesPrizeWinner,
        bingo80: Bingo80PrizeWinner,
        bingo90: Bingo90PrizeWinner,
        bingolite: BingoLitePrizeWinner,
        bloom: BloomPrizeWinner,
        bubblebingo: BubbleBingoPrizeWinner,
        hamsterrace: HamsterRacePrizeWinner,
        morph: MorphPrizeWinner,
        nevada: NevadaPrizeWinner,
        paintbynumbers: PaintByNumbersPrizeWinner,
        picturebingo: PictureBingoPrizeWinner,
        pirates: PiratesPrizeWinner,
        potion: PotionPrizeWinner,
        jigsaw: JigsawPrizeWinner,
        seBingo75: SEBingo75PrizeWinner,
        reelbingo: ReelBingoPrizeWinner,
        bingo30: Bingo30PrizeWinner,
        starship: StarshipPrizeWinner,
        itBingo75: ITBingo75PrizeWinner,
        wordsearch: WordsearchPrizeWinner,
        esPictureBingo: ESPictureBingoPrizeWinner,
        dondBingo: DondBingoPrizeWinner
    };
}

export { PrizeWinnerDataFactory, IPrizeWinnerDataFactory };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/_factory/prize-winner-data-factory.ts